import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-job-referral-link-dialog',
  templateUrl: './job-referral-link-dialog.component.html',
  styleUrls: ['./job-referral-link-dialog.component.scss']
})
export class JobReferralLinkDialogComponent implements OnChanges {
  @Input() isOpen: boolean = false;
  @Input() referralLink: string = '';
  @Input() jobTitle: string = '';
  @Output() onClose = new EventEmitter<void>();
  @Output() onCopy = new EventEmitter<string>();

  isCopied = false;
  displayLink: string = '';

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['referralLink'] || (changes['isOpen'] && this.isOpen)) {
      this.displayLink = this.referralLink || '';
      this.isCopied = false;
    }
  }

  closeDialog(): void {
    this.onClose.emit();
  }

  copyLink(): void {
    if (!this.displayLink) {
      return;
    }

    const isSecure = (window as any).isSecureContext || window.location.protocol === 'https:';
    
    if (navigator.clipboard && isSecure) {
      navigator.clipboard.writeText(this.displayLink).then(() => {
        this.showCopySuccess();
        this.onCopy.emit(this.displayLink);
      }).catch(() => {
        this.fallbackCopy();
      });
    } else {
      this.fallbackCopy();
    }
  }

  private fallbackCopy(): void {
    if (!this.displayLink) {
      return;
    }
    
    const textArea = document.createElement('textarea');
    textArea.value = this.displayLink;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        this.showCopySuccess();
        this.onCopy.emit(this.displayLink);
      } else {
        console.error('Falha ao copiar o link');
      }
    } catch (err) {
      console.error('Erro ao copiar o link:', err);
    } finally {
      document.body.removeChild(textArea);
    }
  }

  private showCopySuccess(): void {
    this.isCopied = true;
    setTimeout(() => {
      this.isCopied = false;
    }, 2000);
  }

  selectAllText(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.select();
    input.setSelectionRange(0, 99999); 
  }
}
